<div class="container">
    <ng-container *ngIf="isReadMode; else writeMode">
        <span>{{ value | multilingualDate:'date' }}</span>
    </ng-container>
    <ng-template #writeMode>
        <div class="write-mode-container si-date-picker" [class.is-disabled]="isDisabled">
            <mat-form-field appearance="outline" class="widthForm">
                <mat-label>Choose a date</mat-label>
                <input matInput 
                       [matDatepicker]="picker" 
                       [disabled]="isDisabled" 
                       [value]="value"
                       (dateChange)="onDateChange($event)"
                       (blur)="onBlur()"
                       [min]="minDate">
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isDisabled"></mat-datepicker-toggle>
                <mat-datepicker #picker [disabled]="isDisabled"></mat-datepicker>
            </mat-form-field>
        </div>
    </ng-template>
</div>